export const usesLightDocumentForeground = (
  inbound: boolean | null | undefined,
): boolean => inbound !== false;
